import { CopySimple } from "@phosphor-icons/react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  Switch,
  Tooltip,
} from "@reactive-resume/ui";
import { AnimatePresence, motion } from "framer-motion";

import { useToast } from "@/client/hooks/use-toast";
import { useUser } from "@/client/services/user";
import { useDialog } from "@/client/stores/dialog";
import { useResumeStore } from "@/client/stores/resume";

export const SharingDialog = () => {
  const { isOpen, close } = useDialog("sharing");
  const { user } = useUser();
  const { toast } = useToast();
  const username = user?.username;

  const setValue = useResumeStore((state) => state.setValue);
  const id = useResumeStore((state) => state.resume.id);
  const isPublic = useResumeStore((state) => state.resume.visibility === "public");

  // 构建分享链接
  const url = `${window.location.origin}/${username}/${id}`;

  const onCopy = async () => {
    await navigator.clipboard.writeText(url);
    toast({
      variant: "success",
      title: "链接已复制到剪贴板",
      description: "任何人都可以通过此链接查看和下载简历。分享到您的个人主页或与招聘人员共享。",
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>分享简历</DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-6">
          <div className="space-y-1.5">
            <div className="flex items-center gap-x-4">
              <Switch
                id="visibility"
                checked={isPublic}
                onCheckedChange={(checked) => {
                  setValue("visibility", checked ? "public" : "private");
                }}
              />
              <div>
                <Label htmlFor="visibility" className="space-y-1">
                  <p>公开</p>
                  <p className="text-xs opacity-60">任何人都可以通过此链接查看和下载简历。</p>
                </Label>
              </div>
            </div>
          </div>

          <AnimatePresence presenceAffectsLayout>
            {isPublic && (
              <motion.div
                layout
                className="space-y-1.5"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Label htmlFor="resume-url">链接</Label>

                <div className="flex gap-x-1.5">
                  <Input readOnly id="resume-url" value={url} className="flex-1" />

                  <Tooltip content="复制到剪贴板">
                    <Button size="icon" variant="ghost" onClick={onCopy}>
                      <CopySimple />
                    </Button>
                  </Tooltip>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </DialogContent>
    </Dialog>
  );
};
